import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePwdComponent } from './components/change-pwd/change-pwd.component';
import { HomeComponent } from './components/home/home.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { Page401Component } from './components/page401/page401.component';
import { Page404Component } from './components/page404/page404.component';
import { A01Guard } from './guards/a01.guard';
import { A02Guard } from './guards/a02.guard';
import { A03Guard } from './guards/a03.guard';
import { A04Guard } from './guards/a04.guard';
import { TestGuard } from './guards/test.guard';
import { RegisterComponent } from './components/register/register.component';
import { BannerComponent } from './components/banner/banner.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { breadcrumb: "" }
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { breadcrumb: "登入" }
      },
      {
        path: 'register',
        component: RegisterComponent,
        data: { breadcrumb: "註冊" }
      },
      {
        path: 'changePwd',
        component: ChangePwdComponent,
        data: { breadcrumb: "修改密碼" },
        canActivate: [TestGuard],
      },
      {
        path: 'class',
        loadChildren: () => import('src/app/components/class/class.module').then(m => m.ClassModule),
        data: { breadcrumb: "" },
        canActivate: [A01Guard],
      },
      {
        path: 'teacher',
        loadChildren: () => import('src/app/components/teacher/teacher.module').then(m => m.TeacherModule),
        data: { breadcrumb: "" },
        canActivate: [A02Guard],
      },
      {
        path: 'student',
        loadChildren: () => import('src/app/components/student/student.module').then(m => m.StudentModule),
        data: { breadcrumb: "" },
        canActivate: [A03Guard],
      },     
      {
        path: 'member',
        loadChildren: () => import('src/app/components/member/member.module').then(m => m.MemberModule),
        data: { breadcrumb: "系統管理" },
        canActivate: [A04Guard],
      },
      {
        path: 'banner',
        component: BannerComponent,
        data: { breadcrumb: "輪播圖" },
        canActivate: [A04Guard],
      },
      {
        path: 'page401',
        component: Page401Component,
        data: { breadcrumb: "權限錯誤" }
      },
      {
        path: '**',
        component: Page404Component,
        data: { breadcrumb: "找不到頁面" }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
